var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckTapered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4942 1.31671L6.56084 12.8334L3.39417 9.45004C2.81084 8.90004 1.89417 8.86671 1.22751 9.33338C0.577506 9.81671 0.394172 10.6667 0.794172 11.35L4.54417 17.45C4.91084 18.0167 5.54417 18.3667 6.26084 18.3667C6.94417 18.3667 7.59417 18.0167 7.96084 17.45C8.56084 16.6667 20.0108 3.01671 20.0108 3.01671C21.5108 1.48338 19.6942 0.133375 18.4942 1.30004V1.31671Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTapered);
export default __webpack_public_path__ + "static/media/CheckTapered.3d34459c.svg";
export { ForwardRef as ReactComponent };